import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { takeLoginFragment } from './lib/email-login';
import { startTracking } from './lib/track';
import './styles.css';

// an emailed link's single-use login token leaves the address bar first (src/lib/email-login.ts)
takeLoginFragment();

// F17: a visitor arriving from a public assessment keeps its id through sign-up, so Home can offer to claim it.
try {
  const a = new URLSearchParams(location.search).get('assessment');
  if (a && /^[0-9a-f-]{36}$/i.test(a)) localStorage.setItem('outlevo.assessment', a);
} catch { /* storage blocked: the claim offer is skipped */ }

// the admin journey: page views, button presses and forms (labels and paths only; src/lib/track.ts)
startTracking();

const qc = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, refetchOnWindowFocus: false } } });

// A tab running an old build after a deploy reloads itself (F25).
const BUILD = import.meta.env.VITE_BUILD ?? 'dev';
setInterval(() => {
  fetch('/build.txt', { cache: 'no-store' }).then((r) => (r.ok ? r.text() : BUILD)).then((b) => { if (b.trim() && b.trim() !== BUILD && BUILD !== 'dev') location.reload(); }).catch(() => undefined);
}, 300_000);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
